import { useRef } from 'react';

import { useShallow } from 'zustand/react/shallow';

import { useReceiveStore } from '~/store';

import type { TypeReceiveDetailOrderItem, TypeReceiveItemErrorState } from '~/types/receive.types';

/**
 * [입고관리 > 입고요청관리] 입고요청 상세 모달 > 입고 상품 테이블 행 유효성검사 커스텀 훅
 */
const useReceiveRequestDetailTableRowValidation = () => {
  const [
    detailModalOrderGoodsList,
    detailModalOrderGoodsListStatus,
    setDetailModalOrderGoodsListStatus,
    resetDetailModalOrderGoodsListStatus,
  ] = useReceiveStore(
    useShallow((state) => [
      state.detailModalOrderGoodsList,
      state.detailModalOrderGoodsListStatus,
      state.setDetailModalOrderGoodsListStatus,
      state.resetDetailModalOrderGoodsListStatus,
    ])
  );

  const firstErrorRowIndexRef = useRef<number | null>(null);

  const validateSingleRow = (row: TypeReceiveDetailOrderItem): TypeReceiveItemErrorState => {
    const isInvalidDate = row.dateUseYn && !row.date;
    const isInvalidQty = row.boxQty === 0 && row.eachQty === 0;
    const isInvalidBoxPerQty = row.boxPerQty === 0;

    return {
      date: isInvalidDate ? 'error' : 'default',
      boxQty: isInvalidQty ? 'error' : 'default',
      boxPerQty: isInvalidBoxPerQty ? 'error' : 'default',
      eachQty: isInvalidQty ? 'error' : 'default',
    };
  };

  const validateAllRows = (): { errorList: TypeReceiveItemErrorState[]; firstErrorRowIndex: number | null } => {
    const errorList = detailModalOrderGoodsList.map(validateSingleRow);
    const _firstErrorIndex = errorList.findIndex((error) => Object.values(error).includes('error'));

    const firstErrorIndex = _firstErrorIndex !== -1 ? _firstErrorIndex : null;

    setDetailModalOrderGoodsListStatus(errorList);
    firstErrorRowIndexRef.current = firstErrorIndex;

    return {
      errorList,
      firstErrorRowIndex: firstErrorIndex,
    };
  };

  const resetRowErrors = () => {
    resetDetailModalOrderGoodsListStatus();
    firstErrorRowIndexRef.current = null;
  };

  return {
    errorList: detailModalOrderGoodsListStatus,
    setErrorList: setDetailModalOrderGoodsListStatus,
    resetErrorList: resetRowErrors,
    validateAllRows,
  };
};

export default useReceiveRequestDetailTableRowValidation;
